import { useMemo } from "react";
import usePagination from "hooks/usePagination";
import type { TableProps } from "@kanda-libs/ks-component-ts/dist";
import useLoanTableSorting from "components/loan/LoanTable/useLoanTableSorting";
import { sortData } from "components/loan/LoanTable/helpers";
import { useSelector } from "react-redux";
import { selectors } from "store";
import paymentSelectors from "store/selectors/payments";
import useSearchQuery from "hooks/useSearchQuery";
import { SEARCH_OPTIONS } from "./constants";

export default function useLoanTableProps(): TableProps {
  const isLoading = useSelector(selectors.getIsLoading);
  const formattedLoans = useSelector(paymentSelectors.getFormattedLoans);

  const { hits } = useSearchQuery(formattedLoans, "loans", SEARCH_OPTIONS);

  const { sorting, order, onAction, onRowClicked } = useLoanTableSorting();

  const {
    pageIndex,
    perPage,
    totalPages,
    setPageIndex: setPage,
  } = usePagination(hits.length);

  const data = useMemo(() => {
    const rawData = hits.map((hit) => hit.item);
    return sortData(rawData, sorting, order).slice(
      pageIndex * perPage,
      pageIndex * perPage + perPage
    );
  }, [order, pageIndex, perPage, sorting, hits]);

  return {
    data,
    onAction,
    pageIndex,
    totalPages,
    setPage,
    onRowClicked: onRowClicked as TableProps["onRowClicked"],
    isLoading,
  } as unknown as TableProps;
}
